import React from 'react';

import { AutoSuggestSelect } from 'src/Admin/components/common/AutoSuggestSelect';
import { DISPLAY_OPTIONS } from '../../../../constants/index';
export const CustomPaginationItemsDisplay = ({
  pageSize,
  setPageSize,
  suffixMessage,
  className = '',
  prefixMessage = '',
  selectClassName = '',
}) => (
  <div
    className={`d-flex align-items-center pagination-items-container-admin ${className}`}
  >
    {prefixMessage && (
      <div className="pagination-prefix">
        <p>{prefixMessage}</p>
      </div>
    )}

    {pageSize && (
      <div className="pagination-count">
        <AutoSuggestSelect
          onChange={setPageSize}
          options={DISPLAY_OPTIONS}
          inputClassName={selectClassName}
          value={{ label: pageSize, value: pageSize }}
          components={{ IndicatorSeparator: () => null }}
        />
      </div>
    )}

    {suffixMessage && (
      <div className="pagination-suffix">
        <p>{suffixMessage}</p>
      </div>
    )}
  </div>
);
